module.exports = __webpack_public_path__ + "img/vip.09d08f30.svg";